import anime from '../libs/anime'

class Module06Logos {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      bandeau();
    }

    let initCache = () => {
      cache.bandeau = document.querySelectorAll('.module-06-logos .bandeau');
    }

    let bandeau = () => {
      for (let i = 0; i < cache.bandeau.length; i++) {
        let bandeau = cache.bandeau[i];
        anime({
          targets: bandeau,
          translateX: ['0%', '-100%'],
          duration: 20000,
          easing: 'linear',
          loop: true,
        });
      }

    }
    initFunc();
  }
}
export { Module06Logos }